import {createContext} from "react";

export interface LogEmployee {
    clinicId: number,
    mEmployeeId: number,
    employeeName: string,
}

export const GraylogContext = createContext<LogEmployee>({} as LogEmployee)
